// @flow
import React from 'react';
import { Text, Flex, Chip, Button, Box } from '@locus-taxy/neo-ui';
import { type TFunction } from 'react-i18next';
import { FpBeat } from 'common/models/internal/FpBeat';
import type { FpPlanViewPagination } from './FpAllocatedVisitsContainer';

type FilterType = {
    value: { label: string, value: string },
    filter: string,
    field: string
};

type FpFilterBarItemProps = {
    selectedFilter: FilterType,
    removeFilterItem: (filter: FilterType) => void
};
class FpFilterBarItem extends React.PureComponent<FpFilterBarItemProps> {
    removeFilter = () => {
        const { selectedFilter, removeFilterItem } = this.props;
        removeFilterItem(selectedFilter);
    };
    render() {
        const { selectedFilter } = this.props;
        let icon;
        switch (selectedFilter.field) {
            case 'salesman':
                icon = 'avatar';
                break;
            case 'salesCategories':
                icon = 'dispatcher_skills_match';
                break;
            default:
                icon = 'calendar_clock';
        }
        return (
            <Box mr={1}>
                <Chip clearable onClear={this.removeFilter} leftIcon={icon}>
                    {
                        // neo label is going multiline in scroll view
                        // https://locussh.atlassian.net/browse/ES-39669
                    }
                    <Text whiteSpace="nowrap">
                        {selectedFilter.value.label}
                    </Text>
                </Chip>
            </Box>
        );
    }
}

type FpPlanViewFilterBarProps = {
    filteredBeats: Array<FpBeat>,
    paginationDetails: FpPlanViewPagination,
    removeFilterItem: (filter: FilterType) => void,
    getAllFilters: () => void,
    onClearFilter: () => void,
    t: TFunction
};
export default class FpPlanViewFilterBar extends React.PureComponent<FpPlanViewFilterBarProps> {
    render() {
        const {
            getAllFilters,
            onClearFilter,
            filteredBeats,
            paginationDetails,
            t,
            removeFilterItem
        } = this.props;
        if (paginationDetails) {
            const allFilters = getAllFilters();
            return (
                <Flex
                    height="56px"
                    bg="grey.100"
                    p={3}
                    pr={0}
                    alignItems="center"
                >
                    <Text fontSize={2} fontWeight={600}>
                        {t('fpPlanView.showingFilteredResult', {
                            visible:
                                filteredBeats.length <
                                paginationDetails.pageSize
                                    ? filteredBeats.length
                                    : paginationDetails.pageSize,
                            total: paginationDetails.totalItems
                        })}
                    </Text>
                    <Flex overflowX="auto" width="calc(100vw - 429px)" ml={3}>
                        {allFilters.map(selectedFilter => {
                            return (
                                <FpFilterBarItem
                                    key={selectedFilter.value.value}
                                    selectedFilter={selectedFilter}
                                    removeFilterItem={removeFilterItem}
                                />
                            );
                        })}
                    </Flex>
                    <Button palette="primary" onClick={onClearFilter}>
                        {t('fpPlanView.clearAll')}
                    </Button>
                </Flex>
            );
        }
        return null;
    }
}
